import React from 'react'
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    InputAdornment
} from '@mui/material'
import { Controller } from 'react-hook-form'
import styles from './DropDownCmp.module.css'

const SelectCmp = ({
    options,
    label,
    style,
    control,
    name,
    placeholder,
    rules,
    startIcon,
    ...props
}) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue=""
            render={({
                field: { onChange, value, onBlur, ref },
                fieldState: { error },
            }) => (
                <FormControl 
                    fullWidth 
                    error={!!error}
                    sx={{ ...style }}
                >
                    <InputLabel id={`${name}-label`}>{label}</InputLabel>
                    <Select
                        labelId={`${name}-label`}
                        id={name}
                        value={value}
                        label={label}
                        onChange={onChange}
                        onBlur={onBlur}
                        inputRef={ref}
                        className={styles.selectBox + " " + props?.className}
                        startAdornment={
                            startIcon && (
                                <InputAdornment position="start">
                                    {startIcon}
                                </InputAdornment>
                            )
                        }
                        {...props}
                    >
                        {options?.map((option, index) => (
                            <MenuItem key={index} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && (
                        <FormHelperText>{error.message}</FormHelperText>
                    )}
                </FormControl>
            )}
        />
    )
}

export default SelectCmp 